import React from 'react';
import { useLocation } from 'react-router-dom';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { Menu } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { useAuth } from '../../context/AuthContext';
import { isStructureLocked } from '../../utils/permissions';

const pageTitles = {
  '/': 'Tableau de bord',
  '/enfants': 'Enfants',
  '/enfants/nouveau': 'Nouvel enfant',
  '/devis': 'Devis',
  '/devis/nouveau': 'Nouveau devis',
  '/contrats': 'Contrats',
  '/rh': 'Ressources Humaines',
  '/finance': 'Finance',
};

function getPageTitle(pathname) {
  if (pageTitles[pathname]) return pageTitles[pathname];
  if (pathname.startsWith('/enfants/') && pathname.endsWith('/modifier')) return 'Modifier enfant';
  if (pathname.startsWith('/enfants/')) return 'Fiche enfant';
  if (pathname.startsWith('/devis/')) return 'Détail devis';
  if (pathname.startsWith('/contrats/')) return 'Détail contrat';
  if (pathname.startsWith('/rh/employes/')) return 'Fiche employé';
  return 'Hello Georges';
}

export default function Header({ onMenu = () => {} }) {
  const location = useLocation();
  const { selectedStructure, structures } = useApp();
  const { user } = useAuth();
  const title = getPageTitle(location.pathname);
  const today = format(new Date(), "EEEE d MMMM yyyy", { locale: fr });
  const todayCapital = today.charAt(0).toUpperCase() + today.slice(1);

  const activeStructure = selectedStructure
    ? structures.find(s => s.id === selectedStructure)
    : null;

  return (
    <header className="bg-cream-50/80 backdrop-blur border-b border-cream-300/60 px-4 sm:px-6 py-3 flex items-center justify-between gap-3 sticky top-0 z-10">
      <div className="flex items-center gap-2 min-w-0">
        {/* Bouton menu (mobile) */}
        <button type="button" onClick={onMenu} className="p-1.5 -ml-1.5 rounded-lg text-navy-500 hover:bg-cream-200 md:hidden flex-shrink-0" aria-label="Menu">
          <Menu size={22} />
        </button>
        <h1 className="font-serif text-[18px] sm:text-[22px] text-navy-900 truncate">{title}</h1>
      </div>
      <div className="flex items-center gap-2 sm:gap-4 flex-shrink-0">
        {/* « Vue générale » n'a de sens que pour un compte multi-structures */}
        {activeStructure ? (
          <span
            className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium text-white max-w-[40vw] truncate"
            style={{ backgroundColor: activeStructure.couleur }}
          >
            <span className="w-1.5 h-1.5 rounded-full bg-white/70 flex-shrink-0" />
            <span className="truncate">{activeStructure.nom}</span>
          </span>
        ) : !isStructureLocked(user?.role) && (
          <span className="badge bg-slate-100 text-slate-600">
            Vue générale
          </span>
        )}
        <span className="text-sm text-gray-500 hidden sm:inline">{todayCapital}</span>
      </div>
    </header>
  );
}
